import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../core/config/core.httpclient-utils';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';
import * as $ from 'jquery';

@Component({
    selector: 'tracker-item-link',
    template: '&nbsp;<a [class]="activeClass" [gf-popover]="details" [title]="title" [href]="url" target="_blank">#{{tid}}</a>'
})
export class TrackerItemLinkComponent implements OnInit {

    @Input() tid: string;
    @Input() popoverType: string = 'details';
    
    private tiData: any;
    protected title: string;
    protected details: string;
    protected activeClass: string = '';
    private isOverElement: boolean = false;
    protected url: string = '';
    private isDelete: boolean = false;
    private el: any;

    private _title = _.template("[#${ tiData.id}] ${ tiData.summary }");

    private _template = _.template(
        '<div class="tracker-item-popover tracker-item-popover-${ popoverType }">' +
        '<div class="tracker-item-popover-details">${ tiData.details }</div>' +
        '</div>'
    );

    constructor(
        private httpClient: HttpClient,
        private stateService: StateService,
        private $element: ElementRef
    ) {
        this.el = $(this.$element.nativeElement);
    }
    
    ngOnInit() {
        this.isDelete = _.get(this.el.attributes, 'activityType', '') == 'delete';
        this.activeClass = this.isDelete ? 'strikethrough' : '';
        this.url = this.isDelete ? '' : this.stateService.href('home.trackeritem', { id: this.tid });

        if (! this.isDelete) {
            this.el.hover(
                this.showPopover,
                this.hidePopover
            );
        }
    }

    showPopover = () => {
        if (this.tiData) {
            this.el.popover('show');
        } else {
            this.isOverElement = true;
            doGetPromise(this.httpClient, '/api/trackeritem', { id: this.tid })
            .then((tiData: any) => {
                this.tiData = tiData;
                this.details = this._template(this);
                this.title = this._title(this);

                this.el.popover({//show popover with data
                    container: 'body',
                    html: true,
                    content: this.details,
                    title: this.title,
                    trigger: 'manual',
                    placement: 'bottom'
                });

                if (this.isOverElement) {
                    this.el.popover('show');
                }
            }, (reject) => console.log(reject) );
        }            
    };

    hidePopover = () => {
        this.isOverElement = false;
        this.el.popover('hide');
    };
}